var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "white",
    fillOpacity: 0.06
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7669 11.5712H20.5093C20.2463 11.5712 19.996 11.4584 19.8219 11.2619L18.9061 10.2274C18.7698 10.0729 18.5734 9.98509 18.3678 9.98509C18.1623 9.98509 17.9659 10.0735 17.8295 10.2274L17.0442 11.1149C16.787 11.4051 16.418 11.5718 16.0304 11.5718H3.67301C3.32106 12.5749 3.09158 13.6344 3 14.7334H14.6658C14.8708 14.7334 15.0672 14.6498 15.2089 14.5018L16.2951 13.3682C16.4308 13.2266 16.6182 13.1467 16.8142 13.1467H16.8589C17.065 13.1467 17.2609 13.2351 17.3972 13.3895L18.3125 14.4241C18.4866 14.6211 18.7368 14.7334 18.9999 14.7334H28.522C28.4304 13.6339 28.201 12.5744 27.849 11.5718H22.7663L22.7669 11.5712Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0596 21.3815C10.2646 21.3815 10.4611 21.2979 10.6027 21.1499L11.6889 20.0163C11.8247 19.8747 12.0121 19.7948 12.208 19.7948H12.2528C12.4588 19.7948 12.6548 19.8832 12.7911 20.037L13.7063 21.0716C13.8804 21.2686 14.1307 21.3809 14.3937 21.3809H27.2979C27.7814 20.3821 28.1355 19.3103 28.3463 18.1873H15.9601C15.6971 18.1873 15.4469 18.0745 15.2728 17.878L14.3575 16.8435C14.2212 16.6891 14.0247 16.6012 13.8192 16.6012C13.6137 16.6012 13.4172 16.6896 13.2809 16.8435L12.4956 17.731C12.2384 18.0212 11.8694 18.1879 11.4813 18.1879H3.1757C3.38655 19.3108 3.74116 20.3826 4.22408 21.3815H10.0591H10.0596Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2144 8.11569C19.4194 8.11569 19.6159 8.0321 19.7575 7.88408L20.8437 6.75051C20.9795 6.60888 21.1669 6.52902 21.3628 6.52902H21.4076C21.6136 6.52902 21.8095 6.6174 21.9458 6.77181L22.8611 7.80634C23.0352 8.00335 23.2855 8.11569 23.5485 8.11569H26.0025C23.6656 5.00943 19.9487 3 15.7615 3C11.5744 3 7.85746 5.00943 5.52004 8.11569H19.2144Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2851 24.5463H10.9291C10.6661 24.5463 10.4158 24.4334 10.2417 24.2369L9.32646 23.2024C9.19016 23.048 8.99369 22.9601 8.78817 22.9601C8.58264 22.9601 8.38617 23.0485 8.24987 23.2024L7.46452 24.09C7.20735 24.3802 6.83837 24.5468 6.45022 24.5468H6.39804C8.73599 27.052 12.0653 28.62 15.7621 28.62C19.4588 28.62 22.7876 27.052 25.1261 24.5468H14.2851V24.5463Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApt);
export default __webpack_public_path__ + "static/media/APT.f9c2e7c575cc55feb67e2f3c12eb9d06.svg";
export { ForwardRef as ReactComponent };